import { useEffect, useRef, useState, useLayoutEffect } from "react";
import styled from "styled-components";

export default function NetworkInfo() {
  return (
    <Wrapper>
      <Button>
        <i className="far fa-envelope" />
      </Button>
      <Button>
        <i className="fas fa-mobile-screen" />
      </Button>
      <Button style={{ backgroundColor: "#D9705E" }}>
        <i className="fas fa-user-plus" />
      </Button>
      <Button style={{ backgroundColor: "#C4C4C4" }}>
        <i className="fas fa-magnifying-glass" />
      </Button>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px;
  gap: 18px;
  position: relative;
  z-index: 100;
`;

const Button = styled.div`
  width: 44px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  border-radius: 18px;
  background: #2867ac;
  cursor: pointer;
`;
